import { Record } from 'immutable';
import { schema } from 'normalizr';

export const CustomerOption = new Record({
  id: undefined,
  customer: undefined,
  charting_option: null,
  requires_po_number_for_orders: undefined,
  requires_auth_name_for_orders: undefined,
  bill_plants_separately: undefined,
  uses_site_group_clusters: undefined,
  sells_digital_panels: false,
  weather_enabled: false,
  webhook_enabled: false,
  comm_fee_3g: '0.00',
  comm_fee_lte: '0.00',
  can_use_bulk_commands: false,
  is_reseller: false,
  uses_relay_monitor_by_default: false,
});

export const customerOptionSchema = new schema.Entity('customerOptions');

// for reading in nested models, object with { field: schema }
// customerOptionSchema.define({  });
